(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('ComercioDeleteController',ComercioDeleteController);

    ComercioDeleteController.$inject = ['$uibModalInstance', 'entity', 'Comercio'];

    function ComercioDeleteController($uibModalInstance, entity, Comercio) {
        var vm = this;

        vm.comercio = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Comercio.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
